import React from 'react';

const CONTEXT_KEY = Symbol.for('@thd-olt-component-react/tab/Context');
const globalSymbols = Object.getOwnPropertySymbols(global);
const hasContext = (globalSymbols.indexOf(CONTEXT_KEY) > -1);

/* istanbul ignore next */
if (!hasContext) {
  global[CONTEXT_KEY] = React.createContext({
    id: null
  });
}

export const TabGroupContext = global[CONTEXT_KEY];